import React, { Component } from 'react';

export default class CheckboxContainer extends Component{
	constructor(props){
		super(props);
		this.handleCheck = this.handleCheck.bind(this);
	}

	handleCheck(identity,checked){ //method that passes up which radio button has been clicked
		this.props.onCheck("value",checked);
	}

	render(){
		let virtues = this.props.virtues;
		const theValues = virtues.map((virtues) => {
      		return (
        			<div key={virtues.ID} className="mv3">
					    <input type="radio" name="virtues" value={virtues.virtue} onClick={(e)=>this.handleCheck(e.target.id,e.target.value)} id={virtues.ID}/>
					    <label htmlFor={virtues.ID}>
					        {virtues.virtue}
					    </label>
					  </div>
  		)});
		return(
			<div>
			{theValues}
			</div>
		);
	}

}


// WEBPACK FOOTER //
// ./src/container/CheckboxContainer.js